import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

export class TranslateHttpLoader implements TranslateLoader {
  constructor(private http: HttpClient, public prefix: string = '/assets/i18n/', public suffix: string = '.json') {
  }

  /**
   * Gets the translations from the server
   * @param lang - the language code in LCID format could be strings like 1033, 1036... (http://www.orbus.be/bosanski_jezik/language_codes.htm)
   */
  public getTranslation(lang: string): any {
    return this.http.get(this.getUrl(lang));
  }

  private getUrl(lang: string) {
    return `${this.prefix}${lang}${this.suffix}`;
  }
}

